import React from 'react';

import { GlobalHeader as GlobalHeaderV2 } from './GlobalHeaderV2/GlobalHeader';

interface IProps {
  isHomePage?: boolean;
  noSearchNavbar?: boolean;
  isFluidPage?: boolean;
  isTransparent?: boolean;
  isSticky?: boolean;
  isSERP?: boolean;
  isHeaderWhite?: boolean;
  isDarkNavigation?: boolean;
  isRvDeliveryPage?: boolean;
  isNewPromoPage?: boolean;
  isRVListingPage?: boolean;
  deferSearchNavigationUntilSubmit?: boolean;
  isCampgroundSearchPage?: boolean;
}

const GlobalHeader: React.FC<IProps> = props => {
  return <GlobalHeaderV2 {...props} />;
};

export default GlobalHeader;
